import { FC, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoaderAnimation from '../components/LoaderAnimation';
import Password from '../services/Password';
import ResetPassword from './ResetPassword';
import styled from 'styled-components';
import GlobalStyles from '../components/GlobalStyles';
import { getUserFromToken } from '../../modules/user_api';
import AuthService from '../../services/auth/authService';

const PageContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 15vh;
`;

const Card = styled.div(({ theme }) => {
  const { color, shadow, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-face: ${type.face};
    background-color: ${color.grayscale[1000]};
    border-radius: 16px;
    box-shadow: ${shadow.dialog};
    padding: 38px 32px;
    width: max(65%, 928px);
    margin: 0 auto;
  `;
});

const Heading = styled.h1(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.larger};
    margin-bottom: 1rem;
  `;
});

const useQuery = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};
//DONE: token is necessary as part of URL and password reset
const ResetPasswordRedirect: FC = () => {
  const query = useQuery();
  const token = query.has('token') ? query.get('token') : false;
  const [error, setError] = useState<boolean>(false);
  const [tokenValid, setTokenValid] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      Password.validateResetToken(token).then((response) => {
        if (response) {
          AuthService.setAuthToken(response.new_reset_token);
          setTokenValid(true);
        } else {
          setError(true);
        }
      });
    } else {
      setError(true);
    }
  }, [token]);

  useEffect(() => {
    if (tokenValid) {
      dispatch(getUserFromToken());
      setLoading(false);
    }
  }, [tokenValid]);

  if (loading) {
    return <LoaderAnimation />;
  }

  if (error) {
    return (
      <PageContainer>
        <Card>
          <Heading>Error</Heading>

          <p>The reset password link provided is either invalid or expired.</p>
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <GlobalStyles />
      <ResetPassword />
    </PageContainer>
  );
};

export default ResetPasswordRedirect;
